export function checkSSO() {
  if (window.location.search.includes('sso=true')) {
    localStorage.setItem('SSO', 'true');
  } else if (window.location.search.includes('sso=false')) {
    localStorage.removeItem('SSO');
  }
  return localStorage.getItem('SSO') === 'true';
}
